import { apiCall } from "./auth";
import { API_URL } from "./config";

export const addStaff = (data, event) => apiCall(`${API_URL}Staff/addStaff`, "POST", data, event);

export const updateStaff = (data, event) => apiCall(`${API_URL}Staff/updateStaff`, "POST", data, event);

export const getStaffById = (data, event) => apiCall(`${API_URL}Staff/getStaffById`, "POST", data, event);

export const getreferralbyid = (data, event) => apiCall(`${API_URL}user/getreferralbyid`, "POST", data, event);

export const getStaffByKeyword = (data, event) => {
    let keyword = data.params.keyword;
    return apiCall(`${API_URL}Staff/searchStaff/?keyword=${keyword}`, "GET", data, event);
}

export const purchaseIronAPI = (data) => apiCall(`${API_URL}user/purchaseironheads`, "POST", data);

export const getStafflistapi = (data) => apiCall(`${API_URL}Staff/getStafflist`, "POST", data);


export const updateuser = (data, event) => apiCall(`${API_URL}Staff/updateuser`, "POST", data, event);

export const updaterefferal = (data, event) => apiCall(`${API_URL}user/updaterefferal`, "POST", data, event);

export const activestaff = (data, event) => apiCall(`${API_URL}Staff/activestaff`, "POST", data, event);

export const activereferral = (data, event) => apiCall(`${API_URL}user/activereferral`, "POST", data, event);

export const updatelocation = (data, event) => apiCall(`${API_URL}Staff/updatelocation`, "POST", data, event);

export const updatefitter = (data, event) => apiCall(`${API_URL}Staff/updatefitter`, "POST", data, event);
 